import {
  EOnboardingModule,
  EOnboardingStep,
  EOnboardingStepStatus,
  EOnboardingSurvey,
  EOnboardingTutorial,
} from './definitions';

export default {
  greeting: 'Рады видеть вас в edna Pulse!',
  modulesTitle: 'Модули edna Pulse для вашего бизнеса',
  modules: {
    [EOnboardingModule.MAX]: {
      title: 'Упрощенная регистрация MAX',
      hint: 'доступно только в edna',
    },
    [EOnboardingModule.DIALOGS]: {
      title: 'Встроенный модуль для переписки',
      hint: 'общайтесь прямо в личном кабинете',
    },
    [EOnboardingModule.TRIGGERS]: {
      title: 'Создание сценариев коммуникации',
      hint: 'без помощи IT-специалистов',
    },
    [EOnboardingModule.CASCADES]: {
      title: 'Резервный канал в каскаде рассылки',
      hint: 'безотказная доставка',
    },
    [EOnboardingModule.INTEGRATION]: {
      title: 'API для легкой интеграции',
      hint: 'и готовые модули',
    },
  },
  stepsTitle: 'Простые шаги к управляемым коммуникациям',
  steps: {
    [EOnboardingStep.COMPANY_DETAILS]: {
      [EOnboardingStepStatus.INITIAL]: 'Заполните реквизиты',
      [EOnboardingStepStatus.COMPLETED]: 'Реквизиты заполнены',
      action: 'Заполнить',
    },
    [EOnboardingStep.CHANNEL]: {
      [EOnboardingStepStatus.INITIAL]: 'Подключите канал общения',
      [EOnboardingStepStatus.IN_PROGRESS]:
        'Канал общения подключен. <0>Ждем регистрацию канала, скоро все заработает</0>',
      [EOnboardingStepStatus.COMPLETED]: 'Канал подключен',
      action: 'Подключить',
    },
    [EOnboardingStep.LICENSE]: {
      [EOnboardingStepStatus.INITIAL]: 'Оплатите лицензию',
      [EOnboardingStepStatus.IN_PROGRESS]:
        'Баланс пополнен. <0>Деньги спишутся автоматически, когда подключится канал</0>',
      [EOnboardingStepStatus.COMPLETED]: 'Лицензия оплачена',
      action: 'Пополнить баланс',
    },
    [EOnboardingStep.INTEGRATION]: {
      [EOnboardingStepStatus.INITIAL]: 'Подключите интеграцию',
      [EOnboardingStepStatus.COMPLETED]: 'Интеграция подключена',
      action: 'К интеграциям',
    },
    [EOnboardingStep.TEMPLATE]: {
      [EOnboardingStepStatus.INITIAL]: 'Согласуйте шаблон',
      [EOnboardingStepStatus.IN_PROGRESS]: 'Шаблон отправлен на регистрацию. <0>Ждем активацию</0>',
      [EOnboardingStepStatus.COMPLETED]: 'Шаблон согласован',
      action: 'Выберите шаблон',
    },
  },
  tariffs: {
    title: 'Каналы',
  },
  survey: {
    title: 'Какие задачи вы решаете?',
    hint: 'Один вопрос, чтобы помочь настроить кабинет под вас:',
    questions: {
      [EOnboardingSurvey.BROADCASTS]: {
        title: 'Рассылки',
        hint: 'Хочу отправлять рассылки',
      },
      [EOnboardingSurvey.INCOMING_MESSAGES]: {
        title: 'Входящие сообщения',
        hint: 'Нужно работать с входящими сообщениями',
      },
      [EOnboardingSurvey.INTEGRATION]: {
        title: 'Интеграция системы',
        hint: 'У меня уже есть CRM/CDP, и мне нужна интеграция',
      },
      [EOnboardingSurvey.EASY_OPERATION]: {
        title: 'Простое управление',
        hint: 'Хочу все делать из понятного интерфейса',
      },
    },
  },
  tutorial: {
    [EOnboardingTutorial.TRIGGERS]: {
      title: 'Сценарии в edna Pulse',
      hint: 'Сценарии автоматизируют общение с клиентами',
      docs: 'Документация',
      pointsTitle: 'Как создать сценарий:',
      points: ['Подключите доступный канал', 'Настройте условие запуска', 'Выберите действие'],
    },
    [EOnboardingTutorial.CASCADES]: {
      title: 'Каскады в edna Pulse',
      hint: 'Каскады обеспечивают доставку сообщения, если основной канал недоступен',
      docs: 'Документация',
      pointsTitle: 'Как создать каскад:',
      points: [
        'Зарегистрируйте минимум 2 канала',
        'Настройте условие запуска',
        'Выберите действие',
      ],
    },
    [EOnboardingTutorial.DIALOGS]: {
      title: 'Диалоги в edna Pulse',
      hint: 'Общайтесь с получателями в личном кабинете',
      docs: 'Документация',
      pointsTitle: 'Как начать диалог:',
      points: ['Подключите канал', 'Загрузите список получателей', 'Отправьте исходящее сообщение'],
    },
    [EOnboardingTutorial.BROADCASTS]: {
      title: 'Рассылки в edna Pulse',
      hint: 'Создавайте рассылки за несколько шагов',
      docs: 'Документация',
      pointsTitle: 'Как запланировать рассылку:',
      points: ['Подключите канал', 'Загрузите список получателей', 'Задайте параметры рассылки'],
    },
  },
};
